module.exports = __webpack_public_path__ + "img/img-Websitebuilding.d7e6a5b7.png";